import { Model } from '@vuex-orm/core';

export default class ElearningPackageActivity extends Model {
    static entity = 'elearning_package_activities';

    static primaryKey = 'id';

    static fields() {
        return {
            id: this.attr(null),
            elearning_package_id: this.attr(null),
            content: this.attr(null),
            content_template_id: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            deleted_at: this.attr(null),
        };
    }
}
